import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '@/zustand/auth-store';

const PublicRoute = () => {
  const accessToken = useAuth(state => state.accessToken);
  const hasHydrated = useAuth(state => state.hasHydrated);
  const { pathname } = useLocation();

  // ---- PAGES THAT SHOULD NOT REDIRECT EVEN IF USER HAS TOKEN ----
  const exceptionRoutes = [];

  const isInExceptionPage = exceptionRoutes.includes(pathname);

  if (!hasHydrated) {
    return null;
  }

  if (accessToken && !isInExceptionPage) {
    return <Navigate to={'/home'} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
